module.exports = __webpack_public_path__ + "img/user7-img5.123cb458.jpg";